import React, { FunctionComponent, useState } from "react";
import { Aside, ButtonProps, CommandBarButton } from "sprint-common-web";

import { CreateGpacMuxSpecificationForm } from "../forms/create/CreateGpacMuxSpecificationForm";

export type AddGpacMuxSpecificationButtonProps = ButtonProps;

export const AddGpacMuxSpecificationButton: FunctionComponent<AddGpacMuxSpecificationButtonProps> = (
    props: AddGpacMuxSpecificationButtonProps
) => {
    const { disabled } = props;

    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <CommandBarButton onClick={openAside} text="Add" icon="Add" disabled={disabled} />
            <Aside isOpen={isAsideOpen} type="form" headerText={"Add GPAC Mux specification"} onDismiss={closeAside}>
                <CreateGpacMuxSpecificationForm onCancel={closeAside} onSubmit={handleFormSubmit} />
            </Aside>
        </>
    );
};
